// The dashboard's `unit.inText.linkStyle` values, verbatim. Its own leaf
// module (re-exported by defaults.js) so boot() can validate a unit's style
// without pulling every other default - and the diagnostics/metrics enums
// defaults.js imports - into the lean boot bundle.
export const INTEXT_LINK_STYLES = Object.freeze({ UNDERLINE: 'underline', HIGHLIGHT: 'highlight' });
